/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Cta_TextInputs */



/**
* | output |
* | --- |
* | "Tell us about your vessel, terminal or operation and we will point you to the right inspection or assessment." |
*
* @param {Services_Cta_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const services_cta_text = /** @type {((inputs?: Services_Cta_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Cta_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("告诉我们您的船舶、码头或作业情况，我们会为您推荐合适的检查或评估。")
	return /** @type {LocalizedString} */ ("Tell us about your vessel, terminal or operation and we will point you to the right inspection or assessment.")
});